
import Vue from "vue";

export default Vue.extend({
	props: {
		bold: Boolean,
		gold: Boolean,
		disabled: Boolean,
		additional: Boolean
	}
});
